import React, {useState} from 'react';
import LayoutOptions from "components/LayoutOptions/LayoutOptions";
import {STab, STabList, STabPanel, STabs} from "./layoutSettingsTabsStyles";

const LayoutSettingsTabs = () => {
    const [, setTabsQuantity] = useState(1)

    return (
        <>
            <STabs
                selectedTabClassName="is-selected"
                selectedTabPanelClassName="is-selected"
                onSelect={(index: number) => setTabsQuantity(index)}
            >
                <STabList>
                    <STab>1</STab>
                    <STab>2</STab>
                    <STab>3</STab>
                    <STab>4</STab>
                </STabList>
                <STabPanel><LayoutOptions tabNumber={1}/></STabPanel>
                <STabPanel><LayoutOptions tabNumber={2}/></STabPanel>
                <STabPanel><LayoutOptions tabNumber={3}/></STabPanel>
                <STabPanel><LayoutOptions tabNumber={4}/></STabPanel>
            </STabs>
        </>
    );
};

export default LayoutSettingsTabs;
